module.exports = __webpack_public_path__ + "img/star-fill-o.92625cbb.svg";